import { render, staticRenderFns } from "./FilePDFIcon.vue?vue&type=template&id=10931648&scoped=true"
var script = {}
import style0 from "./FilePDFIcon.vue?vue&type=style&index=0&id=10931648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10931648",
  null
  
)

export default component.exports